<script setup lang="ts">
const properties = withDefaults(
  defineProps<{
    backgroundColor?: string
    size?: 'container' | 'full'
  }>(),
  {
    backgroundColor: 'sunglow-500',
    size: 'container',
  },
)
</script>

<template>
  <div
    :style="{
      '--background-color': `var(--color-${properties.backgroundColor})`,
    }"
    class="bg-[--background-color]"
  >
    <div
      :class="{
        'max-w-5xl': properties.size === 'container',
        'max-w-7xl': properties.size === 'full',
      }"
      class="mx-auto px-5 pb-12 pt-10 md:px-0"
    >
      <BookingFormProgress />
      <div class="grid grid-cols-12 gap-y-8 md:gap-7">
        <slot />
      </div>
    </div>
  </div>
</template>
